/**
 * GroupProfilePriceUpdateService
 *
 * Service for managing price updates and calculations across GroupProfile controllers.
 * Handles debouncing and coordination of price update requests.
 */

export const GroupProfilePriceUpdateService = {
  priceUpdateTimer: null,
  priceUpdateDelay: 500,

  isPriceUpdatePending: false,
  lastPriceUpdateData: null,

  schedulePriceUpdate(callback, delay = this.priceUpdateDelay) {
    this.isPriceUpdatePending = true;

    if (this.priceUpdateTimer) {
      clearTimeout(this.priceUpdateTimer);
    }

    this.priceUpdateTimer = setTimeout(() => {
      callback();
      this.isPriceUpdatePending = false;
    }, delay);
  },

  cancelPriceUpdate() {
    if (this.priceUpdateTimer) {
      clearTimeout(this.priceUpdateTimer);
      this.priceUpdateTimer = null;
      this.isPriceUpdatePending = false;
    }
  },

  hasPendingUpdate() {
    return this.isPriceUpdatePending;
  },

  setLastUpdateData(data) {
    this.lastPriceUpdateData = JSON.stringify(data);
  },

  hasDataChanged(data) {
    const currentData = JSON.stringify(data);
    return currentData !== this.lastPriceUpdateData;
  },

  dispatchPriceUpdateEvent(element, priceData) {
    const event = new CustomEvent("group-profile:price-updated", {
      bubbles: true,
      cancelable: true,
      detail: priceData,
    });
    element.dispatchEvent(event);
  },

  dispatchPriceUpdateRequestEvent(element, formData) {
    const event = new CustomEvent("group-profile:price-update-requested", {
      bubbles: true,
      cancelable: true,
      detail: { formData },
    });
    element.dispatchEvent(event);
  },

  reset() {
    this.cancelPriceUpdate();
    this.lastPriceUpdateData = null;
  },
};

export default GroupProfilePriceUpdateService;
